module.exports = __webpack_public_path__ + "static/media/ptp.ed928284.png";